import { Field, Form, Formik } from "formik";
import React, { useCallback, useEffect, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as Yup from "yup";
import crose from "../../../../assets/images/icons/crose.svg";
import editColor from "../../../../assets/images/icons/edit-color.svg";
import edit from "../../../../assets/images/icons/edit.svg";
import TextInput from "../../../../components/formfields/InputField";
import AddTaskForm from "../../../accountComplete/components/todo";
import { getResourceDetailsAction } from "../../../App/actions";
import { uploadFileAction, uploadFileNewAction } from "../editHome/actions";
import { addResourceCMSDataAction } from "./actions";
import ProgressiveImage from "react-progressive-graceful-image";
import Blur from "../../../../assets/images/spinner-icon-gif-19.jpg";
import DeleteModel from "../membership/deleteModel";
import "./style.scss";
import SubmitLoader from "../../../../components/SubmitLoader";

const validationSchema = Yup.object({
  name: Yup.string().required("Name can not be empty"),
  excerpt: Yup.string().required("Excerpt can not be empty"),
  hero_title: Yup.string().required("Title can not be empty"),
  hero_paragraph: Yup.string().required("Paragraph can not be empty"),
  hero_image: Yup.string().required("Background image can not be empty"),
});

const EditResourceCMS = (props) => {
  const [generalEdit, setGeneralEdit] = useState(false);
  const [heroEdit, setHeroEdit] = useState(false);
  const [imgError, setImgError] = useState("");

  const [keywords, setKeywords] = useState([]);
  const addKeywords = (text) => setKeywords([...keywords, text]);
  const removeExpertise = (index) => {
    const newTasks = [...keywords];
    newTasks.splice(index, 1);
    setKeywords(newTasks);
  };
  const initialState = {
    name: props.resource_cms?.name ? props.resource_cms?.name : "",
    url: props.resource_cms?.url ? props.resource_cms?.url : "/resources",
    excerpt: props.resource_cms?.excerpt ? props.resource_cms?.excerpt : "",
    thumbnail: props.resource_cms?.thumbnail ? props.resource_cms?.thumbnail : "",
    hero_title: props.resource_cms?.hero_title ? props.resource_cms?.hero_title : "",
    hero_paragraph: props.resource_cms?.hero_paragraph ? props.resource_cms?.hero_paragraph : "",
    hero_image: props.resource_cms?.hero_image ? props.resource_cms?.hero_image : "",
  };

  const handleSubmit = (values) => {
    setImgError("");
    const form_data = new FormData();
    form_data.append("name", values.name);
    form_data.append("excerpt", values.excerpt);
    form_data.append("keyword", keywords);
    form_data.append("thumbnail", values.thumbnail);
    form_data.append("hero_title", values.hero_title);
    form_data.append("hero_paragraph", values.hero_paragraph);
    form_data.append("hero_image", values.hero_image);
    props.addResourceCMSDataAction(form_data, setGeneralEdit);
    setHeroEdit(false);
  };

  useEffect(() => {
    props.getResourceDetailsAction();
  }, []);
  useEffect(() => {
    setKeywords(props.resource_cms?.keyword ? props.resource_cms?.keyword : []);
  }, [props.resource_cms?.keyword]);

  const handleUpload = (event, fieldValue, name, oldImage) => {
    const formData = new FormData();
    formData.append("file", event.currentTarget.files[0]);
    formData.append("folder", "resource-cms-page");
    formData.append("url", oldImage ? oldImage : "");
    props.uploadFileNewAction(formData, fieldValue, name);
  };
  const handleImageUpload = (event, fieldValue, name) => {
    const imgType =
      event.currentTarget.files[0]?.type === "image/gif" ||
      event.currentTarget.files[0]?.type === "image/png" ||
      event.currentTarget.files[0]?.type === "image/jpg" ||
      event.currentTarget.files[0]?.type === "image/jpeg" ||
      event.currentTarget.files[0]?.type === "image/webp";

    if (imgType) {
      const file = event.target.files[0];
      handleUpload(event, fieldValue, name, oldImage);
      const URL = window.URL || window.webkitURL;
      const img = new Image();
      const objectUrl = URL.createObjectURL(file);
      img.src = objectUrl;
      img.onload = function handleImageLoad() {
        // fieldValue(name, event.target.files[0]);
        const reader = new FileReader();
        reader.onload = (e) => {
          fieldValue("dummyImage", e?.target?.result);
        };
        reader.readAsDataURL(event.target.files[0]);
      };
    } else {
      setImgError("Background Image only allows file types of JPG,PNG and GIF.");
    }
  };

  const onImageChange = useCallback((event, fieldValue, name, oldImage, dummyImage) => {
    const imgType =
      event.currentTarget.files[0]?.type === "image/gif" ||
      event.currentTarget.files[0]?.type === "image/png" ||
      event.currentTarget.files[0]?.type === "image/jpg" ||
      event.currentTarget.files[0]?.type === "image/jpeg" ||
      event.currentTarget.files[0]?.type === "image/webp";

    if (imgType) {
      const file = event.target.files[0];
      handleUpload(event, fieldValue, name, oldImage);
      const URL = window.URL || window.webkitURL;
      const img = new Image();
      const objectUrl = URL.createObjectURL(file);
      img.src = objectUrl;
      img.onload = function handleImageLoad() {
        // fieldValue(name, event.target.files[0]);
        const reader = new FileReader();
        reader.onload = (e) => {
          fieldValue(dummyImage, e?.target?.result);
        };
        reader.readAsDataURL(event.target.files[0]);
      };
    } else {
      setImgError("Background Image only allows file types of JPG,PNG and GIF.");
    }
  }, []);

  const handleRemove = useCallback((field, fieldValue, dummyImage) => {
    fieldValue(field, "");
    fieldValue(dummyImage, "");
  }, []);

  // VARIABLES generalEdit FOR CLASS
  const generalEditTitleClass = generalEdit ? "editTitle" : "";
  const generalEditFieldClass = generalEdit ? "editField" : "";
  const generalEditLableClass = !generalEdit ? " editLabel" : "";
  const generalEditInputStyleClass = generalEdit ? "editField inputStyle" : "inputStyle";
  const generalImageLableClass = !generalEdit ? "imageLabel editImageLabel" : "imageLabel";

  // VARIABLES heroEdit FOR CLASS
  const heroEditTitleClass = heroEdit ? "editTitle" : "";
  const heroEditFieldClass = heroEdit ? "editField" : "";
  const heroEditLableClass = !heroEdit ? " editLabel" : "";
  const heroImageLableClass = !heroEdit ? "imageLabel editImageLabel" : "imageLabel";

  // changed the map key
  return (
    <>
      <div className="blackListArea">
        <div className="adminContainer">
          <div className="row">
            <div className="col-lg-8 offset-lg-2">
              <div className="d-flex flex-wrap align-items-center justify-content-between titleBoxWrap mb-25">
                <h2 className="adminSectionTitle">Resources Page</h2>
                <span className="edit">
                  <img src={edit} alt="edit" />
                </span>
              </div>

              <Formik enableReinitialize initialValues={initialState} validationSchema={validationSchema} onSubmit={handleSubmit}>
                {({ values, handleChange, handleBlur, setFieldValue, errors, touched }) => {
                  return (
                    <Form className="usefulFeatureForm">
                      <h3 className={`resourceAddTitle ${generalEditTitleClass}`}>
                        General Info
                        {generalEdit ? (
                          <button onClick={() => setImgError("")} className="savebtn" type="submit">
                            Save <img src={editColor} alt="" />
                          </button>
                        ) : (
                          <span onClick={() => setGeneralEdit(true)} className="edit">
                            <span>Edit</span> <img src={edit} alt="edit" />
                          </span>
                        )}
                      </h3>
                      <div className="usefulFeatureFormBG mb-50">
                        <Field
                          label="Name"
                          name="name"
                          component={TextInput}
                          value={values.name}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          placeholder="Name"
                          readOnly={!generalEdit}
                          disabled={!generalEdit}
                          className={generalEditFieldClass}
                        />

                        <div className={generalEditInputStyleClass}>
                          <label htmlFor="url">URL</label>
                          <Field name="url" type="text" id="url" value={values.url} placeholder="URL" readOnly disabled />
                        </div>
                        <div className="multilineForm">
                          <label className={generalEditLableClass}>Excerpt</label>
                          <Field
                            name="excerpt"
                            component={TextInput}
                            value={values.excerpt}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            placeholder="Excerpt"
                            readOnly={!generalEdit}
                            className={generalEditFieldClass}
                            multiline
                            disabled={!generalEdit}
                          />
                        </div>
                        <div className={`inputStyle ${generalEditFieldClass}`}>
                          <label>Keywords</label>
                          {generalEdit ? <AddTaskForm addTask={addKeywords} placeholder="Keywords" /> : ""}
                          <ul className="todo-list">
                            {keywords?.map((task, index) => (
                              <li key={task} className="todo">
                                <span className="label">{task}</span>
                                {generalEdit ? (
                                  <span className="delete" onClick={() => removeExpertise(index)}>
                                    <img src={crose} alt="delete" />
                                  </span>
                                ) : (
                                  ""
                                )}
                              </li>
                            ))}
                          </ul>
                        </div>
                        <label className={generalImageLableClass} htmlFor="image">
                          Thumbnail
                        </label>
                        <div className="uploadImage">
                          {values.dummyThumbnailImage || values.thumbnail ? (
                            <div className="fileImage">
                              <>
                                {values.thumbnail ? (
                                  <>
                                    <img src={values.dummyThumbnailImage || values.thumbnail} alt="imagesss" />
                                    {generalEdit ? (
                                      <DeleteModel
                                        onClick={() => {
                                          setFieldValue("oldThambnailImage", values?.thumbnail);
                                          handleRemove("thumbnail", setFieldValue, "dummyThumbnailImage");
                                        }}
                                      />
                                    ) : null}
                                  </>
                                ) : (
                                  <div className="position-absolute top-50 text-center w-100 translate-middle-y">
                                    <SubmitLoader />
                                  </div>
                                )}
                              </>
                            </div>
                          ) : (
                            <button component="label" className="inputFileBtn" type="button">
                              <h5>Upload File</h5>
                              <span className="fileText">(jpg, png, gif)</span>
                              <span className="fileBtn">Add Item</span>
                              <input
                                id="thumbnail"
                                name="thumbnail"
                                type="file"
                                onChange={(e) => {
                                  setImgError("");
                                  onImageChange(e, setFieldValue, "thumbnail", values?.oldThambnailImage, "dummyThumbnailImage");
                                }}
                              />
                            </button>
                          )}
                        </div>
                      </div>
                      <h3 className={`resourceAddTitle ${heroEditTitleClass}`}>
                        Hero Section
                        {heroEdit ? (
                          <button className="savebtn" type="submit">
                            Save <img src={editColor} alt="" />
                          </button>
                        ) : (
                          <span onClick={() => setHeroEdit(true)} className="edit">
                            <span>Edit</span> <img src={edit} alt="edit" />
                          </span>
                        )}
                      </h3>
                      <div className="usefulFeatureFormBG">
                        <Field
                          label="Title"
                          name="hero_title"
                          component={TextInput}
                          value={values.hero_title}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          placeholder="Title"
                          readOnly={!heroEdit}
                          className={heroEditFieldClass}
                        />

                        <div className="multilineForm">
                          <label className={heroEditLableClass}>Paragraph</label>
                          <Field
                            name="hero_paragraph"
                            component={TextInput}
                            value={values.hero_paragraph}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            placeholder="Paragraph"
                            readOnly={!heroEdit}
                            className={heroEditFieldClass}
                            multiline
                          />
                        </div>

                        <label className={heroImageLableClass} htmlFor="image">
                          Images
                        </label>
                        <div className="uploadImage">
                          {values.dummyHeroImage || values.hero_image ? (
                            <div className="fileImage">
                              <ProgressiveImage src={`${values.dummyHeroImage || values.hero_image}`} placeholder={Blur}>
                                {(src, loading) => <img className={`image${loading && !imgError ? " loading" : " loaded"}`} src={src} alt="sea beach" />}
                              </ProgressiveImage>
                              {heroEdit ? (
                                <DeleteModel
                                  onClick={() => {
                                    setFieldValue("oldHeroImage", values?.thumbnail);
                                    handleRemove("hero_image", setFieldValue, "dummyHeroImage");
                                  }}
                                />
                              ) : null}
                            </div>
                          ) : (
                            <button component="label" className="inputFileBtn" type="button">
                              <h5>Upload File</h5>
                              <span className="fileText">(jpg, png, gif)</span>
                              <span className="fileBtn">Add Item</span>
                              <input
                                id="thumbnail"
                                name="hero_image"
                                type="file"
                                onChange={(e) => {
                                  setImgError("");
                                  onImageChange(e, setFieldValue, "hero_image", values?.oldHeroImage, "dummyHeroImage");
                                }}
                              />
                            </button>
                          )}
                          {((errors.hero_image && touched.hero_image) || imgError) && <p className="errorMsg mb-0">{imgError || errors.hero_image}</p>}
                        </div>
                      </div>
                    </Form>
                  );
                }}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  resource_cms: state.cms.resource_cms,
});

export default connect(mapStateToProps, {
  getResourceDetailsAction,
  uploadFileAction,
  addResourceCMSDataAction,
  uploadFileNewAction,
})(withRouter(EditResourceCMS));
